var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCart16 = function SvgCart16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.674.5A.676.676 0 0 0 0 1.182c0 .378.3.682.674.682h1.273c.11 0 .202.08.222.187l1.464 8.134a2.03 2.03 0 0 0 1.99 1.679h7.19a.676.676 0 0 0 .673-.682c0-.378-.3-.682-.674-.682h-7.19a.68.68 0 0 1-.663-.56l-.143-.804h8.53c.865 0 1.607-.622 1.767-1.483l.871-4.713a.906.906 0 0 0-.885-1.076H3.504l-.012-.057A1.58 1.58 0 0 0 1.944.5zm5.17 15c.358 0 .7-.144.954-.4a1.37 1.37 0 0 0 0-1.928 1.34 1.34 0 0 0-1.907 0 1.37 1.37 0 0 0 0 1.929c.252.255.595.399.953.399m6.294 0c.357 0 .7-.144.953-.4a1.37 1.37 0 0 0 0-1.928 1.34 1.34 0 0 0-1.907 0 1.37 1.37 0 0 0 0 1.929c.253.255.596.399.954.399"
  })));
};
export default SvgCart16;